module.exports = __webpack_public_path__ + "static/media/icon-calendar.f49e220e.svg";